import { render, staticRenderFns } from "./ForecastMulti.vue?vue&type=template&id=b1a885e0&"
import script from "./ForecastMulti.vue?vue&type=script&lang=js&"
export * from "./ForecastMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports